var GalleryType;
(function (GalleryType) {
    GalleryType["DEFAULT"] = "default";
    GalleryType["HOVER_CONTENT"] = "hover-content";
    GalleryType["OVERLAY"] = "overlay";
})(GalleryType || (GalleryType = {}));
export { GalleryType, };
//# sourceMappingURL=gallery-constants.js.map